/**
 * @generated SignedSource<<a81b79df32a0e78b9299cf83e4a811b2>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type IssueActions$data = {
  readonly " $fragmentSpreads": FragmentRefs<"IssueActionsPermissions" | "IssueActionsState">;
  readonly " $fragmentType": "IssueActions";
};
export type IssueActions$key = {
  readonly " $data"?: IssueActions$data;
  readonly " $fragmentSpreads": FragmentRefs<"IssueActions">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "IssueActions",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "IssueActionsPermissions"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "IssueActionsState"
    }
  ],
  "type": "Issue",
  "abstractKey": null
};

(node as any).hash = "49401fe3482d695005b4860257e659c0";

export default node;
